import React from 'react';

export const UserProfile = () => {
  const text = 'User Profile';

  return <h1>{text}</h1>;
};
